var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import env from '../core/env';
import { getRequestMetricsParam } from './metrics';
/**
 * 规范上报参数
 * @param {string} url 链接
 * @param {object} response 请求
 * @param {number} beforeTime 发送前
 * @returns {*} 规范后
 */
function formatParams(response, url, beforeTime) {
    var res = {
        data: {}
    };
    if (typeof response === 'string') {
        try {
            res.data = JSON.parse(response);
        }
        catch (e) {
            res.data = {};
            res.data.st = -1;
        }
    }
    else {
        res = __assign({}, response);
    }
    res.config = res.config || {};
    res.config.beforeTime = beforeTime;
    res.config.url = url;
    return res;
}
/**
 * jsb回调后的钩子
 * @param {string} url 链接
 * @param {object} response response
 * @param {number} beforeTime 时间
 * @returns {undefined} 无
 */
function afterJsb(response, url, beforeTime) {
    var afterTime = new Date().getTime();
    setTimeout(function () {
        var params = formatParams(url, response, beforeTime);
        getRequestMetricsParam(params, afterTime, 'jsb');
    }, 0);
}
/**
 * 头条调用fetch后请求处理
 * @param response
 * @param url
 * @param beforeTime
 */
function handleToutiaoJsb(response, url, beforeTime) {
    if (response && Number(response.code) === 1) {
        afterJsb(url, response, beforeTime);
        if (Number(response.status) === 200) {
            try {
                response.data = JSON.parse(response.response);
                return response;
            }
            catch (e) {
                return e;
            }
        }
        else {
            return response;
        }
    }
    else {
        throw new Error('jsb failed');
    }
}
/**
 * 抖音调用fetch后请求处理
 * @param response
 * @param url
 * @param beforeTime
 */
function handleDouyinJsb(response, url, beforeTime) {
    try {
        afterJsb(url, response._raw, beforeTime);
        response.data = JSON.parse(response._raw);
        return response;
    }
    catch (e) {
        return e;
    }
}
/**
 * 火山调用fetch后请求处理
 * @param response
 * @param url
 * @param beforeTime
 */
function handleHuoshanJsb(response, url, beforeTime) {
    if (response && Number(response.code) === 1) {
        afterJsb(url, response, beforeTime);
        try {
            response.data = response.raw;
            return response;
        }
        catch (e) {
            return e;
        }
    }
    else {
        throw new Error('jsb failed');
    }
}
/**
 * 处理fetch返回参数
 * @param response
 * @param url
 * @param beforeTime
 */
export var handleFetchResponse = function (response, url, beforeTime) {
    if (env.isInToutiao || env.isInToutiaoLite) {
        return handleToutiaoJsb(response, url, beforeTime);
    }
    else if (env.isInAweme) {
        return handleDouyinJsb(response, url, beforeTime);
    }
    else if (env.isInHotsoon) {
        return handleHuoshanJsb(response, url, beforeTime);
    }
    else {
        throw new Error('env failed');
    }
};
/**
 * 默认处理复杂post数据结构方式
 * @param data
 */
export var processFetchData = function (data) {
    var transformsData = {};
    try {
        transformsData = {
            json_form: JSON.stringify(data)
        };
    }
    catch (e) {
        transformsData = {
            json_form: data
        };
    }
    return transformsData;
};
